import { Component, OnInit, Input } from '@angular/core';
import { LoansService, StorageService } from 'src/app/_services';

@Component({
  selector: 'app-request-notification',
  templateUrl: './request-notification.component.html',
  styleUrls: ['./request-notification.component.css']
})
export class RequestNotificationComponent implements OnInit {
  @Input() requestId;

  notifications = [];
  loading = false;
  currentUser: any;

  constructor(
    private loansService: LoansService,
    public storageService: StorageService,
  ) {
    this.currentUser = this.storageService.read<any>('currentUser');
  }

  ngOnInit() {
    this.loadNotifications();
  }

  loadNotifications() {
    this.loading = true;
    this.loansService.getRequestNotifications(this.currentUser.token, this.requestId).subscribe(res => {
      this.notifications = res.response;
      this.loading = false;
    }, err => {
      console.log({ err });
      this.loading = false;
    });
  }
}
